import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit, OnDestroy {
  public isDesktopCollapsed = false;
  public isMobile = false;
  private subscription: Subscription = new Subscription();

  get sidebarCollapsed(): boolean {
    return this.isMobile ? false : this.isDesktopCollapsed;
  }

  constructor() { }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkScreenSize();
  }

  ngOnInit() {
    this.checkScreenSize();
    this.loadSavedState();

    const storageListener = (e: StorageEvent) => {
      if (e.key === 'desktopSidebarCollapsed' && e.newValue !== null) {
        this.isDesktopCollapsed = JSON.parse(e.newValue);
      }
    };
    
    window.addEventListener('storage', storageListener);
    
    const intervalId = setInterval(() => {
      const currentState = localStorage.getItem('desktopSidebarCollapsed');
      if (currentState !== null) {
        const parsedState = JSON.parse(currentState);
        if (parsedState !== this.isDesktopCollapsed) {
          this.isDesktopCollapsed = parsedState;
        }
      }
    }, 100);

    this.subscription.add(() => {
      window.removeEventListener('storage', storageListener);
      clearInterval(intervalId);
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  private checkScreenSize(): void {
    this.isMobile = window.innerWidth <= 768;
  }

  private loadSavedState(): void {
    const savedState = localStorage.getItem('desktopSidebarCollapsed');
    if (savedState !== null) {
      this.isDesktopCollapsed = JSON.parse(savedState);
    }
  }
}
